import React, { Fragment, useEffect, useState } from "react";
import "../../utils/select2_4.0.js";
import $ from 'jquery';
import "../../assets/VagaroStyle/select2.css"

const MultiSelect = (props) => {
    const [placeHolderName, setPlaceHolderName] = useState(props.placeholder);
    const Control = {
        ControlID: "#" + props.ControlID
    }

    useEffect(() => {
        if (props.ControlID != null && props.ControlID !== undefined) {
            ApplySelect2();
        }

    }, [props.options]);



    const OpenMultiSelect = () => {
        $('.select2-container').addClass("driveFormMselect datepicker-width");
        $('.select2-container').addClass(props.ControlID);
        $('.driveFormMselect .selectall').addClass("AllCustomer");
        $('.driveFormMselect .selectnone').addClass("NoneCustomer");
        $(".NoneCustomer").on("click", function () {
            $(Control.ControlID).select2("val", "");
            if (props.ControlID === "ddlSelectPayRates") {
                props.setPlaceholder(placeHolderName)
            }
            else {
                setPlaceHolderName(props.placheholderFlag === true ? placeHolderName : props.placeholder)
            }
        });


        // add new 
        if (props.isHaveAddnewCategory) {
            var a = $(Control.ControlID).data('select2');
            if (!$('.select2-link-add').length) {
                a.$results.parents('.select2-results')
                    .append('<div class="select2-link-add"><a><i class="far fa-plus"></i> Edit Categories</a></div>');
                a.$results.parents('.select2-results').find(".select2-link-add").on('click', function (b) {
                    //console.log($(this).text() + "--cliekd");
                    a.trigger('close');
                    clickToOpen();
                    // add your code
                });
            }
        };
    }

    const clickToOpen = () => {
        props.addNewcategoryFun();
    }
    const OnChangeMultiSelect = () => {
        props.onChange($('#' + props.ControlID).val().join(', '));

    }
    const CloseMultiSelect = () => {

        $('.select2-container').removeClass("driveFormMselect");
        if (props.isHaveAddnewCategory) {
            var a = $(Control.ControlID).data('select2');
            if (!$('.select2-link-add').length) {
                a.$results.parents('.select2-results').find(".select2-link-add").remove();
            }
        }
    }

    const ApplySelect2 = () => {
        if (props.GroupSelect) {
            $(Control.ControlID).select2({
                placeholder: props.placeholder,
                dropdownAutoWidth: true,
                width: '100%',
                templateResult: function (obj) {
                    if (!obj.id) { return obj.text; }
                    var $obj = $(
                        '<span class="multicheck-checkbox"></span><label class="labelpadd">' + obj.text + '</label>'
                    );
                    return $obj;
                },
                selectAll: 1,
                closeOnSelect: false,
                searchInputPlaceholder: props.searchInputPlaceholder,
            });
        }else{
            $(Control.ControlID).select2({
                placeholder: props.placeholder,
                dropdownAutoWidth: true,
                width: '100%',
                templateResult: function (obj) {
                    if (!obj.id) { return obj.text; }
                    var $obj = $(
                        '<span class="multicheck-checkbox"></span><label class="labelpadd">' + obj.text + '</label>'
                    );
                    return $obj;
                },
                selectAll: 1,
                closeOnSelect: false,
                searchInputPlaceholder: props.searchInputPlaceholder,
                matcher: function (params, data) {
                if ($.trim(params.term) === '') {
                        return data;
                    }
    
                    const term = $.trim(params.term).toLowerCase();
                    const words = term.split(' ');
                    const text = data.text.toLowerCase();
    
                    const isMatch = words.every(word => text.includes(word));
    
                    if (isMatch) {
    
                        const modifiedData = $.extend({}, data, true);
                        words.forEach(word => {
                            modifiedData.text = modifiedData.text.replace(
                                new RegExp('(' + word + ')', 'gi'),
                                '<strong>$1</strong>'
                            );
                        });
                        return modifiedData;
                    }
                    return null;
                }
            });
        }
    }

    // const closeMultiSelectOnTouchMove = () => {
    //     document.addEventListener('scroll', function (e) {
    //         if ($(Control.ControlID + '.expandedWidth').length > 0) {
    //             $(Control.ControlID + '.expandedWidth').select2('close');
    //         }
    //     }, true);
    // }




    useEffect(() => {
        ApplySelect2();
        $(Control.ControlID).on("change", function (e) {
            OnChangeMultiSelect()
        })
        $(Control.ControlID + '.expandedWidth').on('select2:open', function (e) {
            OpenMultiSelect();
            //closeMultiSelectOnTouchMove();
        })
        $(Control.ControlID + '.expandedWidth').on('select2:close', function (e) {
            CloseMultiSelect()
        });

    }, [props.placeholder]);

    useEffect(() => {
        if (!props.isValidSubCategoryId) {
            setTimeout(function () {
                $(window).trigger('resize');
            }, 5)

        } else {
            setTimeout(function () {
                $(window).trigger('resize');
            }, 5)
        }
    }, [props.isValidSubCategoryId])


    const OptionSelect = (item) => {
        var FilterCategory = props.defaultValue.filter(
            (col) => col === item.id
        );
        if (FilterCategory.length > 0) {
            return true;
        }
        else {
            return false;
        }
    }

    return (
        <Fragment>
            <div>
                <fieldset>
                    {props.GroupSelect ? 
                      <select id={props.ControlID} className="expandedWidth form-control" multiple="true" data-select-all="1" >
                      <option value='' hidden>{props.placeholder}</option>
                      {props.options.length > 0 && 
                        (props.options).map((data, index) => (
                          <optgroup label={data.text}>
                              {(data?.children || []).map((sdata, i) => (
                                  <option selected={OptionSelect(sdata) === true ? "selected" : ""} value={sdata.id}>{sdata.text}</option>
                              ))}
                          </optgroup>
                        ))
                    }
                    </select>
                    :
                    <select id={props.ControlID} className="expandedWidth vgselect-dropdown prosale-select2" multiple="true" data-select-all="1" >
                        {props.options.length > 0
                            && props.options.map((item) =>
                            <option selected={OptionSelect(item) === true ? "selected" : ""} value={item.id}>{item.name}</option>
                            )};
                    </select>
                    }
                </fieldset>
            </div>
        </Fragment>
    )
};

export default MultiSelect;